export function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/ed6c76ef60678986b5cb04b32aa24004.jpg"
          alt="Sala de Terapia Acolhedora"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full">
        <h2
          className="text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-6 drop-shadow-lg"
          style={{ fontFamily: 'Cormorant Garamond, serif' }}
        >
          Terapia Faz Bem
        </h2>
        <div className="bg-white/90 backdrop-blur-sm rounded-3xl px-8 py-6 mb-12 max-w-3xl mx-auto shadow-xl">
          <p className="text-xl md:text-2xl text-[#2C2C2C] leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            Transforme sua vida em um espaço seguro e acolhedor. Aqui você encontra o apoio profissional que precisa para sua jornada de autoconhecimento e bem-estar emocional.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => scrollToSection('agendar')}
            className="bg-[#7DD3C0] text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-[#6BC4B0] transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
          >
            Agendar Minha Sessão
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
          <button
            onClick={() => scrollToSection('servicos')}
            className="border-2 border-white text-white bg-white/20 backdrop-blur-sm px-8 py-4 rounded-full text-lg font-medium hover:bg-white hover:text-[#7DD3C0] transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Conhecer Serviços
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white drop-shadow-lg"></i>
      </div>
    </section>
  );
}